import {
  FETCH_RATES_REQUEST,
  FETCH_RATES_SUCCESS,
  FETCH_RATES_FAILURE,
  CREATE_RATE_REQUEST,
  CREATE_RATE_SUCCESS,
  CREATE_RATE_FAILURE,
  UPDATE_RATE_REQUEST,
  UPDATE_RATE_SUCCESS,
  UPDATE_RATE_FAILURE,
  DELETE_RATE_REQUEST,
  DELETE_RATE_SUCCESS,
  DELETE_RATE_FAILURE,
} from "./types";

import { fetchRates, createRate, updateRate, deleteRate } from "../../services/ratesServices";

// Fetch Rates
export const fetchRatesAction = () => async (dispatch) => {
  dispatch({ type: FETCH_RATES_REQUEST });
  try {
    const response = await fetchRates();
    if (response.success) {
      dispatch({ type: FETCH_RATES_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: FETCH_RATES_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({ type: FETCH_RATES_FAILURE, payload: error.message || "Failed to fetch rates" });
  }
};

// Create Rate
export const createRateAction = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_RATE_REQUEST });
  try {
    const response = await createRate(payload);
    if (response.success) {
      dispatch({ type: CREATE_RATE_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: CREATE_RATE_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({ type: CREATE_RATE_FAILURE, payload: error.message || "Failed to create rate" });
  }
};

// Update Rate
export const updateRateAction = (id, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_RATE_REQUEST });
  try {
    const response = await updateRate(id, payload);
    if (response.success) {
      dispatch({ type: UPDATE_RATE_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: UPDATE_RATE_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({ type: UPDATE_RATE_FAILURE, payload: error.message || "Failed to update rate" });
  }
};

// Delete Rate
export const deleteRateAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_RATE_REQUEST });
  try {
    const response = await deleteRate(id);
    if (response.success) {
      dispatch({ type: DELETE_RATE_SUCCESS, payload: id });
    } else {
      dispatch({ type: DELETE_RATE_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({ type: DELETE_RATE_FAILURE, payload: error.message || "Failed to delete rate" });
  }
};
